// extracted by mini-css-extract-plugin
export var cell = "_4z-4";
export var headerCell = "_4z-2";
export var rowHeader = "_4z-3";
export var table = "_4z-1";
export var tableContainer = "_4z-0";